// extracted by mini-css-extract-plugin
export default {"link":"XEdaR0dgJX","last":"GxfMopLXK7"};